import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    width: 100%;
  `,
  title: css`
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  `,
  variant: {
    school: css`
      background: linear-gradient(
        180deg,
        #e6e6e6 0%,
        rgba(230, 230, 230, 0) 100%
      );
    `,
    community: css`
      background: linear-gradient(
        180deg,
        #dfe1e7 0%,
        rgba(223, 225, 231, 0) 100%
      );
    `,
  },
  cardTitle: css`
    color: ${colors.charcoal} !important;
    text-transform: capitalize;
    @media (min-width: 800px) {
        padding-bottom: 8px;
    }
  `,
  content: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: ${pxToRem(218)};;
  `,
  cardInfoList: css`
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    gap: 12px;
    padding: 24px 27px 56px;
    @media (min-width: 800px) {
      padding: 24px 32px 30px;
    }
  `,
  swiper: css`
    .swiper {
      position: relative;
    }
    .swiper-slide {
      border-radius:10px;
      padding-top: 32px;
      @media (min-width: 800px) {
        padding-top: 17px;
      }
    }

  `,
  cardIllustration: css`
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
    object-fit: cover;
    width: 100%;
  `,
  hide: css`
    visibility: hidden;
  `,
  customPagination: css`
    display: flex;
    justify-content: center;
    gap: 4px;
    list-style-type: none;
    padding: 0px;
    margin: 0px;
`,
paginationButton: css`
  background: ${colors.stone};
  border: none;
  border-radius: 50%;
  width: ${pxToRem(8)};
  height: ${pxToRem(8)};
  padding: 0px;
  cursor: pointer;
  position: relative;
  outline: none;
  transition: background-color 0.3s ease;
  &:focus-visible {
    box-shadow: 0 0 0 2px #cccccc, 0 0 0 4px ${colors.focusOutlineColor};
  }
`,
paginationButtonActive: css`
  background: ${colors.charcoal};
  &:focus-visible {
    box-shadow: 0 0 0 2px ${colors.prussian}, 0 0 0 4px ${colors.focusOutlineColor};
  }
`,
};

export default styles;
